import { configureStore } from "@reduxjs/toolkit";
import advancedTableReducer from "./slices/advancedTableSlice";
import requestReducer from "./slices/requestsSlice";
import wallpaperReducer from "./slices/wallpaperSlice";

export const store = configureStore({
  reducer: {
    advancedTable: advancedTableReducer,
    requests: requestReducer,
    wallpaper: wallpaperReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
